import { h } from 'preact';
import PlusIcon from 'utils/icon/icon-plus.svg';
import MinusIcon from 'utils/icon/icon-minus.svg';
import clsx from 'clsx';

const QuantitySelector = ({
  quantity,
  handleQuantityChange,
  disabled,
  maxQuantity = Infinity,
  productTitle,
  currentVariant
}) => (
  <div className="flex max-h-[45px] items-center gap-15 rounded border border-primary px-4 lg:px-16">
    <button
      type="button"
      className={clsx(
        'w-20 text-right focus:ring-offset-0',
        quantity <= 1 ? 'text-grey-2' : 'text-primary'
      )}
      onClick={() => handleQuantityChange(quantity - 1)}
      aria-label={window.TMW.Strings.product.decrease}
      disabled={quantity <= 1}
    >
      <MinusIcon />
    </button>
    <input
      type="number"
      id="quantityInput"
      value={quantity}
      min="1"
      max={currentVariant?.inventoryManagement === 'shopify' && 
        currentVariant?.inventoryPolicy === 'deny' ? 
        maxQuantity : null}
      aria-label={window.TMW.Strings.product.quantityInput}
      className="body-14-med flex h-40 w-20 items-center justify-center border-none p-0 text-center text-primary"
      onChange={(e) => {
        const value = parseInt(e.target.value, 10);
        if (Number.isNaN(value)) return;
        
        // Only validate max quantity if inventory is tracked
        if (currentVariant?.inventoryManagement === 'shopify' && value > maxQuantity) {
          const toastEvent = new CustomEvent('cart:notification', {
            detail: {
              message: `Only ${maxQuantity} ${productTitle} are available. Quantity updated.`,
              type: 'warning',
              duration: 5000,
            },
          });
          document.dispatchEvent(toastEvent);
          handleQuantityChange(maxQuantity);
          e.target.value = maxQuantity.toString();
          return;
        }
        
        handleQuantityChange(value);
      }}
      onBlur={(e) => {
        const value = parseInt(e.target.value, 10);
        if (Number.isNaN(value) || value < 1) {
          handleQuantityChange(1);
        }
      }}
    />
    <button
      type="button"
      className={clsx(
        'w-20 text-left focus:ring-offset-0',
        (disabled || (
          currentVariant?.inventoryManagement === 'shopify' && 
          currentVariant?.inventoryPolicy === 'deny' && 
          quantity >= maxQuantity
        ) ? 'text-grey-2' : 'text-primary')
      )}
      onClick={() => handleQuantityChange(quantity + 1)}
      aria-label={window.TMW.Strings.product.increase}
      disabled={disabled || (
        currentVariant?.inventoryManagement === 'shopify' && 
        currentVariant?.inventoryPolicy === 'deny' && 
        quantity >= maxQuantity
      )}
    >
      <PlusIcon />
    </button>
  </div>
);

export default QuantitySelector;
